import React from 'react';
import PageContainer from '../../components/PageComponents/layouts/PageContainer';
import SafetyNav from '../../components/SafetyNav';
import List from './List';

const breadcrumbs = [{ label: 'Toolbox Talks', isActive: true }];

const SafetyToolboxTalks = () => (
  <PageContainer heading="TOOLBOX TALKS" breadcrumbs={breadcrumbs}>
    <SafetyNav />
    <List />
  </PageContainer>
);

export default SafetyToolboxTalks;
